module.exports = __webpack_public_path__ + "img/IMG_6258_L_Black.440a2f4c.jpg";